module.exports = {"component":"carousel","status":"prod","display-name":"Carousel","SLDS-component-path":"/components/carousel","url-slug":"carousel"}


//////////////////
// WEBPACK FOOTER
// ./components/carousel/docs.json
// module id = 201
// module chunks = 0